<div class="row text-center">
  <div class="col">
    <div class="header-icon full-icon">
      <img src="./assets/img/images/expired.svg" alt="no match" />
    </div>
    <h1 class="title-copy no-margin-bottom">{{ 'REVIEW_AND_UPDATE' | translate }}</h1>
  </div>
</div>
<div class="row margin-vertical mv24 text-center">
  <div class="col fs-18">
    <div>{{ 'POLICY_INFO_HOLDER_NAME' | translate }}:&nbsp;<strong>{{ policyHolderName }}</strong></div>
    <div>{{ 'POLICY_INFO_NUMBER' | translate }}:&nbsp;<strong>{{ policyNumber }}</strong></div>
  </div>
</div>
<div>
  <div class="text-center margin-vertical mv24 ma-red-link">
    <mapfre-link
      additionalClasses="horizontal-space red-link underline d-inline-block margin-bottom mb24 dm-sans-medium fs-16"
      [routerLink]="['/signup','edit-policy']">
      {{ 'EDIT_POLICY_INFO' | translate }}
    </mapfre-link>

    <div>
      <mapfre-button additionalClasses="basic primary large-btn" [routerLink]="['/signup','add-policy']">
        {{ 'TRY_AGAIN_WITH_A_DIFFERENT' | translate }}
      </mapfre-button>
    </div>
  </div>
</div>
<div class="ma-footer-assistance">
  <div class="row">
    <div class="col text-center">
      <div class="margin-bottom mb8 ma-assistance-text grey-color">{{ 'NOTFOUND_NEED_ASSISTANCE' | translate }}</div>
      <div>
        <a href="tel:{{ 'CUSTOMER_SERVICE_NUMBER' | translate }}"
          class="mapfre link blue-link corporate-red dm-sans-medium font-weight-500 fs-16">
          {{ "CUSTOMER_SERVICE_NUMBER" | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
<div class="row margin-top mt16 text-center">
  <div class="col">
    <div class="grey-color">
      This application is only available for MA policies.
    </div>
  </div>
</div>